import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { stylingHelpers } from '../../designTokens';
import Spacing from '../layout/Spacing';
import ColorProvider from '../chrome/ColorProvider';
import Heading from '../chrome/Heading';
import Text from '../chrome/Text';
import Image from '../chrome/Image';

const { flexStack } = stylingHelpers;

const baseStyles = () => css`
  ${flexStack()};
  text-align: center;
`;

const Container = styled('div')(baseStyles);

const imageContainerBaseStyles = ({ theme }) => css`
  margin-bottom: ${theme.spacings.byte};
`;

const ImageContainer = styled('div')(imageContainerBaseStyles);

const styledHeadingBaseStyles = ({ theme }) => css`
  margin-bottom: ${theme.spacings.bit};
  line-height: 24px;
`;

const StyledHeading = styled(Heading)(styledHeadingBaseStyles);

const PrizeItem = ({ type, count, title, details, assetUrl, assetAlt }) => (
  <Container>
    <ColorProvider variant='grey'>
      <Text bold upper noMargin>
        {type}
      </Text>
    </ColorProvider>
    <ColorProvider variant='red'>
      <Heading as='h4' size='exa' upper designer noMarginBoth>
        {count}
      </Heading>
    </ColorProvider>
    <Spacing sides double>
      <ColorProvider variant='brown'>
        <StyledHeading as='h3' size='mega' noMarginBoth>
          {title}
        </StyledHeading>
      </ColorProvider>
      <ColorProvider variant='lightBrown'>
        <Text size='giga' noMargin>
          {details}
        </Text>
      </ColorProvider>
    </Spacing>
    <Spacing top>
      <ImageContainer>
        <Image src={assetUrl} alt={assetAlt} />
      </ImageContainer>
    </Spacing>
  </Container>
);

PrizeItem.propTypes = {
  type: PropTypes.string,
  count: PropTypes.string,
  title: PropTypes.string,
  details: PropTypes.string,
  assetUrl: PropTypes.string,
  assetAlt: PropTypes.string,
  variant: PropTypes.string,
};

PrizeItem.defaultProps = {
  type: 'Prize Type',
  count: '60x',
  title: 'This is some example title text for this Prize Item',
  details: 'This is some details text for this Prize Item!',
  assetUrl: 'https://via.placeholder.com/210x145',
  variant: 'right',
};

export default PrizeItem;
